import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DistributorsState } from 'types';

export const initialState: DistributorsState = {
  loading: false,
  distributorList: [],
  reset: false
};

const slice = createSlice({
  name: 'Distributors',
  initialState,
  reducers: {
    setDistributorsList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.reset = false;
      state.distributorList = payload || [];
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setDistributorsList, reset } = slice.actions;

export default slice.reducer;
